import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { MyTicketCinejoy } from '../../spotlight/models/my-ticket-cinejoy/my-ticket-cinejoy.model';
import { MyTicketScreeningParties } from '../../spotlight/models/my-ticket-screening-parties/my-ticket-screening-parties.model';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.css'],
})
export class MyTicketsComponent implements OnInit {
  spotlightsTickets: MyTicketCinejoy[] = new Array();
  showcaseTickets: MyTicketCinejoy[] = new Array();
  screeningPartiesTickets: MyTicketScreeningParties[] = new Array();
  isLoading = false;
  timezone:any;
  timezoneSpotlight: any

  constructor(
    private agileIntegration: AgileIntegrationService,
    public activeModal: NgbActiveModal
  ) {
    this.fetchTickets();
  }

  ngOnInit(): void {
    var zone = moment.tz.guess();       
    this.timezone = moment.tz(zone).format("z");
    // this.pacificTimezone = moment().tz("America/Los_Angeles").format('Z');

  }

 // All dates returns in Pacific time from Agiletix for creatics platform

  //Following returns Pacific Time Zone Value (-08:00 / -07.00)
  pacificTimezone(date:any){
   
    const time = moment(date).tz("America/Los_Angeles").format('Z')
    var pacificTZ = time
    return pacificTZ;

  }

  //Following function returns user's current timezone name
  userTimezoneName(date:any){
   
    const time = moment(date).tz("America/Los_Angeles").format('Z')
    var pacificTZ = date+time
    var newDate = new Date(pacificTZ).toString();
    var zone = moment.tz.guess();       
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  //Following function returns user's current timezone name for Screening Party
  userTimezoneNameSP(date:any){
   
    var zone = moment.tz.guess();   
    var newDate = new Date(date).toString()    
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  fetchTickets(): void {
    this.isLoading = true;
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        this.isLoading = false;
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        // If StartDateTime format is in epoch time which is the number of seconds that have elapsed since January 1, 1970. then uncomment following code.

        // tickets.forEach((ticket) => {
        //   if (!(ticket.StartDateTime instanceof Date)) {
        //     ticket.StartDateTime = new Date(
        //       parseInt(ticket.StartDateTime.split('(')[1].split(')')[0])
        //     );
        //   }
        //   if (!(ticket.PurchaseDate instanceof Date)) {
        //     ticket.PurchaseDate = new Date(
        //       parseInt(ticket.PurchaseDate.split('(')[1].split(')')[0])
        //     );
        //   }
        //   if (!(ticket.EndDateTime instanceof Date)) {
        //     ticket.EndDateTime = new Date(
        //       parseInt(ticket.EndDateTime.split('(')[1].split(')')[0])
        //     );
        //   }
        // });

        this.spotlightsTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('spotlight')
        );
     
        this.showcaseTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('showcase')
        );
        this.showcaseTickets = this.showcaseTickets.sort((a, b) =>
          a.Name.localeCompare(b.Name, 'en', { numeric: true })
        );
        this.screeningPartiesTickets = response.screeningParties ? response.screeningParties : [];
        this.screeningPartiesTickets.forEach((ticket) => {          
          if (ticket.meetingDateTime) {
              ticket.meetingDateTime = new Date(
                ticket.meetingDateTime
              );
          }
        });

      },
      (error) => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }

  closeModal(): void {
    this.activeModal.close();
  }

  selectTicket(type, ticket): void {
    console.log(ticket)
    let url;
    switch (type) {
      case 'showcase':
        url = `/cinejoy/showcase/moviepage/${ticket.ParentID}/${this.getmovieName(ticket.Name)}`;
        break;
      case 'spotlights':
        url =
          '/cinejoy/premiere/more-info/' +
          ticket.ParentID +
          '/' +
          ticket.Name.replaceAll(' ', '-');
        break;
      case 'screeningParties':
        url = '/cinejoy/screening-parties/join';
        break;
    }
    location.href = url;
  }

  getmovieName(moviename){
    let name = moviename.replace(/ /g, '-');
    return name;
  }
}
